function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ScrollSyncPane } from 'react-scroll-sync';
import RowRenderer from './RowRenderer';
import { Skeleton } from '../../Skeleton';
import styles from '@dtsl/css-data-table/dist/index.module.css';
function Rows(props) {
  const {
    rows,
    isLoading,
    showPagination,
    noRowRenderer,
    dataTableBodyClass,
    noOfSkeletonRows
  } = props;
  const dataTableBodyClassNames = classNames({
    [styles['sib-data-table__rows']]: true,
    [styles['syncscroll']]: true,
    [styles['row-data-rounded']]: !showPagination,
    [dataTableBodyClass]: !!dataTableBodyClass
  });
  return /*#__PURE__*/React.createElement(ScrollSyncPane, null, /*#__PURE__*/React.createElement("tbody", {
    className: dataTableBodyClassNames,
    name: "data-table-elements"
  }, isLoading || rows.length === 0 && !isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, rows.length === 0 && !isLoading ? /*#__PURE__*/React.createElement("tr", {
    className: styles['sib-data-table-no-rows']
  }, /*#__PURE__*/React.createElement("td", null, noRowRenderer())) : Array(noOfSkeletonRows).fill(true).map((_, index) => {
    return /*#__PURE__*/React.createElement("tr", {
      className: styles['sib-data-table-loading-container'],
      key: index
    }, Array(6).fill(true).map((_, index) => /*#__PURE__*/React.createElement("td", {
      key: index
    }, /*#__PURE__*/React.createElement(Skeleton, {
      height: 24,
      style: {
        borderRadius: '8px'
      }
    }))));
  })) : rows.map((row, index) => {
    return /*#__PURE__*/React.createElement(RowRenderer, _extends({
      key: `${row.id}_${index + 1}`
    }, props, {
      row: row,
      idx: index
    }));
  })));
}
Rows.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  noRowRenderer: PropTypes.func.isRequired,
  showPagination: PropTypes.bool.isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  noOfSkeletonRows: PropTypes.number.isRequired,
  dataTableBodyClass: PropTypes.string
};
export default Rows;